import cloneDeep from 'lodash/cloneDeep';

import Account from 'redpoints-model-js/model/account/Account';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';
import { getLinkByLinkServiceResponse } from 'redpoints-front-common/services';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK_ERROR,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK_FAILURE,
  INCIDENT_DETAILS_SAVE_CONTENT_LINK_SUCCESS,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE,
  INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS,
  INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT_REQUEST,
  INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT_SUCCESS,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS,
} from '../../../actions/actionTypes';

export const additionalActionsReducer = (state, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SAVE_CONTENT_LINK_ERROR:
    case INCIDENT_DETAILS_SAVE_CONTENT_LINK_FAILURE:
    case INCIDENT_DETAILS_SAVE_CONTENT_LINK_SUCCESS: {
      const newState = cloneDeep(state);
      newState.data.contentLink = getLinkByLinkServiceResponse(
        state.data.contentLink,
        action
      );
      return newState;
    }
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_ERROR:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_FAILURE:
    case INCIDENT_DETAILS_SAVE_DETECTION_LINK_SUCCESS: {
      const newState = cloneDeep(state);
      newState.data.detectionLink = getLinkByLinkServiceResponse(
        state.data.detectionLink,
        action
      );
      return newState;
    }
    case INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT_REQUEST: {
      const newState = cloneDeep(state);
      newState.data.contentLink.account = null;
      return newState;
    }
    case INCIDENT_DETAILS_SEARCH_CONTENT_LINK_ACCOUNT_SUCCESS: {
      const newState = cloneDeep(state);
      newState.data.contentLink.account = Object.assign(
        new Account(),
        action.payload.response.data
      );
      return newState;
    }
    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST: {
      const newState = cloneDeep(state);

      newState.data.detectionLink.account = null;
      return newState;
    }
    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS: {
      const newState = cloneDeep(state);

      newState.data.detectionLink.account = Object.assign(
        new Account(),
        action.payload.response.data
      );
      return newState;
    }
    default:
      return state;
  }
};

const incidentData = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA,
  additionalActionsReducer
);

export default incidentData;
